import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";

class Hero1 extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    this.tl.to(this.hero, time, { opacity: 1 });
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.hero,
      time,
      { opacity: 1 },
      { transform: "translateX(-80px)", opacity: 0 }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div id="hero1" className="section" ref={hero => (this.hero = hero)}>
        <div id="heroText" className="heroText ">
          <span className="ht1">We create effective</span>
          <div>
            <span className="ht2">business automation solutions </span>
            <span className="ht3">&</span>
          </div>
          <div className="ht4">web based applications</div>
          <span className="ht5">from MVP to the final product</span>
        </div>
      </div>
    );
  };
}

export default Hero1;



// WEBPACK FOOTER //
// ./src/components/Front/Hero1.js